import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { toast } from '@kmgestao/ui';

/**
 * Detecta nova versão do Service Worker em segundo plano e avisa via toast.
 * O usuário clica "Atualizar" → `updateServiceWorker(true)` recarrega com o
 * build novo. Se ignorar, atualiza automaticamente no próximo carregamento.
 *
 * Monte uma única vez no root (`main.tsx`).
 */
export function PwaUpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    offlineReady: [offlineReady, setOfflineReady],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(registration) {
      if (!registration) return;
      // Checa atualização a cada 60 min em sessões longas (ex: abas abertas).
      setInterval(() => void registration.update(), 60 * 60 * 1000);
    },
  });

  useEffect(() => {
    if (needRefresh) {
      toast('Nova versão disponível', {
        description: 'Recarregue para ver as últimas melhorias.',
        duration: Infinity,
        action: {
          label: 'Atualizar',
          onClick: () => {
            setNeedRefresh(false);
            void updateServiceWorker(true);
          },
        },
        onDismiss: () => setNeedRefresh(false),
      });
    }
  }, [needRefresh, setNeedRefresh, updateServiceWorker]);

  useEffect(() => {
    if (offlineReady) {
      toast.success('App pronto para uso offline', {
        description: 'Páginas já visitadas funcionam sem conexão.',
        duration: 6000,
        onAutoClose: () => setOfflineReady(false),
        onDismiss: () => setOfflineReady(false),
      });
    }
  }, [offlineReady, setOfflineReady]);

  return null;
}
